export const energyMap = {
  "Classe A+++":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/Class_Ammm.png?11546741979213448708",
  "Classe A++":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/Class_Amm.png?11546741979213448708",
  "Classe A+":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/Class_Am.png?11546741979213448708",
  "Classe A":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/Class_A.png?11546741979213448708",
  "Classe B":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/Class_B.png?11546741979213448708",
  "Classe C":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/Class_C.png?11546741979213448708",
  "Classe D":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/Class_D.png?11546741979213448708",
  "Classe E":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/Class_E-min.png?292857",
  "energy-a":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/energy-new-classe-A.png?v=1615745697",
  "energy-b":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/energy-new-classe-B.png?v=1615745711",
  "energy-c":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/energy-new-classe-C.png?v=1615745717",
  "energy-d":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/energy-new-classe-D.png?v=1615745724",
  "energy-e":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/energy-new-classe-E.png?v=1615745734",
  "energy-f":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/energy-new-classe-F.png?v=1615745775",
  "energy-g":
    "https://cdn.shopify.com/s/files/1/2700/1230/files/energy-new-classe-G.png?v=1615745783",
};
